export const letterSpacing = {
  'normal': '0em',
  '0.5%': '.005em',
  '1%': '.01em',
  '1.5%': '.015em',
  '2%': '.02em',
  '3%': '.03em',
}
